var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.61 26.625H26.49C26.355 26.745 26.22 26.8501 26.085 26.9701L19.68 31.77C17.565 33.345 14.115 33.345 11.985 31.77L5.56501 26.9701C4.15501 25.9201 3 23.595 3 21.84V10.725C3 8.89503 4.39501 6.87003 6.10501 6.22503L13.575 3.42004C14.805 2.95504 16.845 2.95504 18.075 3.42004L25.53 6.22503C26.955 6.76503 28.17 8.26504 28.545 9.79504H17.595C17.265 9.79504 16.965 9.81005 16.68 9.81005C13.905 9.97505 13.185 10.98 13.185 14.145V22.29C13.2 25.74 14.085 26.625 17.61 26.625Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1992 16.8301H32.9992",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9992 14.1301V22.4551C32.9692 25.7851 32.0542 26.6101 28.5892 26.6101H17.6092C14.0842 26.6101 13.1992 25.7251 13.1992 22.2601V14.1151C13.1992 10.9651 13.9192 9.96011 16.6942 9.78011C16.9792 9.78011 17.2792 9.76514 17.6092 9.76514H28.5892C32.1142 9.78014 32.9992 10.6501 32.9992 14.1301Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9805 22.8901H18.9754",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.125 22.8901H27.03",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.849454ca4bb7e5f5d1e0bd271c78974d.svg";
export { ForwardRef as ReactComponent };